import { render, staticRenderFns } from "./ExpertCommentListBlock.vue?vue&type=template&id=69ec60bd&scoped=true"
import script from "./ExpertCommentListBlock.vue?vue&type=script&lang=js"
export * from "./ExpertCommentListBlock.vue?vue&type=script&lang=js"
import style0 from "./ExpertCommentListBlock.vue?vue&type=style&index=0&id=69ec60bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ec60bd",
  null
  
)

export default component.exports